// extracted by mini-css-extract-plugin
export var blogContainer = "news-module--blogContainer--2E2Ml";
export var sidebarContainer = "news-module--sidebarContainer---Tv6o";
export var sidebar = "news-module--sidebar--lUSVg";
export var categoryTitle = "news-module--categoryTitle--9323n";
export var categoriesContainer = "news-module--categoriesContainer--ZWUcZ";
export var category = "news-module--category--3nioh";